module.exports = __webpack_public_path__ + "static/media/back.c17ee212.png";